import React, { useState, useEffect } from "react";
import Select from 'react-select';
import { alert_error, alert_success } from "../AppContext.js";
import axios from 'axios';
import moment from 'moment';
import ClockPicker from './clock.jsx';
import { BsCalendar } from 'react-icons/bs';
import { FaTrash } from 'react-icons/fa';

const Scheduler = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [datafile, setdatafile] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState("Xác nhận");
    const [service, setservice] = useState('');
    const [start_date, setstart_date] = useState('');
    const [end_date, setend_date] = useState('');
    const [options, setOptions] = useState([
        { label: 'Một lần', value: 'oneshort' },
        { label: 'Hàng ngày', value: 'daily' },
    ]);
    const handleTextToSpeech = () => {
        console.log();
        console.log();
        console.log(start_date);
        console.log(selectedTime);
    };
    const handleDateChange = (event) => {
        setstart_date(event.target.value);
    };
    const handleDateChange2 = (event) => {
        setend_date(event.target.value);
    };
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleChange = (selectedOption) => {
        setservice(selectedOption.value);
        setIsOpen(false);
    };
    useEffect(() => {
        getfile();
    }, []);
    function getfile() {

        axios.get('https://hust.media/truyenthanh/cron/file.php')
            .then(response => {
                console.log(response.data); // Dữ liệu từ API
                setdatafile(response.data);
                // Xử lý dữ liệu ở đây
            })
            .catch(error => {
                alert_error(error);
            });
    };
    const [selectedItem, setSelectedItem] = useState(null);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
    };
    const [selectedTime, setSelectedTime] = useState('12:00');

    useEffect(() => {
        // Thực hiện mọi thứ mà bạn muốn khi có sự thay đổi về thời gian
        console.log('Selected Time Changed:', selectedTime);
    }, [selectedTime]);
    return (
        <>
            <div className="max-w-2xl px-1 py-2   mx-auto rounded-lg shadow-xl ">

                <div className="mx-auto container-fluid mt-0  flex  flex-col  items-center justify-center ">

                    <label htmlFor="countries2" className="text-center text-xs  mb-0  font-medium">
                        Chọn kiểu lịch
                    </label>
                    <Select
                        className="w-full max-w-md"
                        classNamePrefix="Chọn 1 lựa chọn"
                        onFocus={handleFocus}
                        options={options}
                        menuIsOpen={isOpen}
                        onBlur={handleBlur}
                        onMenuOpen={handleMenuOpen}
                        onChange={handleChange} // Use selectedOption.value to get the selected value
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={false}
                    />

                    <div className="flex items-center mb-2 mt-1">
                        <div className="px-5 flex-col">
                            <label>Ngày bắt đầu:</label>
                            <div className="flex">
                                <div className="flex items-center">
                                    <BsCalendar size={20} />
                                    <input
                                        type="date"
                                        value={start_date}
                                        onChange={handleDateChange}
                                        className="mb-0 ml-2"
                                    />
                                </div>
                                {start_date && <p className="mb-0 px-2 selected-date">
                                    {moment(start_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                </p>}
                            </div>
                        </div>
                        {service == 'daily' && (<>
                            <div className="flex-col">
                                <label>Ngày kết thúc</label>
                                <div className="flex">
                                    <div className="flex items-center">
                                        <BsCalendar size={20} />
                                        <input
                                            type="date"
                                            value={end_date}
                                            onChange={handleDateChange2}
                                            className="mb-0 ml-2"
                                        />
                                    </div>
                                    {end_date && <p className="mb-0 px-2 selected-date">
                                        {moment(end_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                    </p>}
                                </div>          </div>    </>)}

                    </div>
                    <ClockPicker onSelect={(time) => setSelectedTime(time)} />
                    {selectedTime && <p>Selected Time: {selectedTime}</p>}
                    {datafile && (<>
                        <div className="table-responsive overflow-x-hidden">
                            <table className="table align-middle table-flush table-sm table-bordered">
                                <thead className="thead-light" >
                                    <tr>
                                        <th className="text-lowercase text-center" style={{ width: "5%" }} scope="row">
                                            Chọn
                                        </th>
                                        <th className="text-center" style={{ width: "10%" }} scope="row">
                                            Tên File
                                        </th>
                                        <th className="text-lowercase text-center" style={{ width: "15%" }} scope="col">
                                            Thời lượng
                                        </th>
                                        <th className="text-center" style={{ width: "10%" }} scope="row">
                                            Ngày update
                                        </th>
                                        <th className="text-center" style={{ width: "5%" }} scope="row">
                                            Xoa
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {datafile.map((item, index) => (

                                        <tr key={index}>

                                            <td onClick={() => handleSelectItem(item)} className="text-center py-2 px-1 border-b">
                                                <input
                                                    type="radio"
                                                    name="audioSelect"
                                                    checked={selectedItem === item}
                                                />
                                            </td>
                                            <td onClick={() => handleSelectItem(item)} className="py-2 px-4 border-b">{item.file_name}</td>
                                            {/* <td className="py-2 px-4 border-b">{item.full_path}</td> */}
                                            <td onClick={() => handleSelectItem(item)} className="py-2 px-4 border-b">{item.time}</td>
                                            <td onClick={() => handleSelectItem(item)} className="text-center py-2 px-1 border-b">{moment(item.modified_time).format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td className="text-center py-2 item-center border-b"><div className="flex items-center justify-center">
                                                <FaTrash />
                                            </div></td>
                                        </tr>


                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <button
                            disabled={nutxuly == 1}
                            onClick={handleTextToSpeech}
                            className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                        >
                            <div className="flex items-center justify-between flex-1">
                                {nutxuly == 1 && (
                                    <div className="spinner-border" role="status"></div>
                                )}

                                <span className="text-xl font-medium text-white">
                                    {nutorder}{" "}
                                </span>

                                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                            </div>
                        </button>
                    </>)}

                </div> </div></>

    )
}

export default Scheduler;